<template>
    <div class="legend">
        <div v-if="show" v-click-outside="hide"></div>
        <div class="legend__action">
            <button class="btn-legend shade" @click="toggle" :class="isActive">
                {{ $t('map.legend_title') }}
            </button>
        </div>
        <transition name="fade">
            <div class="legend__inner sub shade" v-if="show">
                <ul class="legend__list">

                    <li class="legend__item">
                        <div class="legend__checkbox">
                            <v-checkbox
                                    v-model="isCheckAll"
                                    type="checkbox"
                                    required
                                    hide-details
                                    color="#2C64FF"
                                    :ripple="false"
                                    @change="checkAll"
                            >
                            </v-checkbox>
                        </div>
                        <div class="legend__content">
                            <div class="legend__title" >
                                {{ $t("layersSelectAll") }}
                            </div>
                        </div>

                    </li>

                    <li class="legend__item" v-for="legend in list" :key="legend.id">
                            <div class="legend__checkbox">
                                <v-checkbox
                                        v-model="checkbox"
                                        :value="legend.id"
                                        type="checkbox"
                                        required
                                        hide-details
                                        color="#2C64FF"
                                        :ripple="false"
                                        @change="checkboxChangeHandler(legend)"
                                >
                                </v-checkbox>
                            </div>
                            <div class="legend__content">
                                <div class="legend__marker">
                                    <i class="legend__icon markers markers-sm" :class="legend.icon"></i>
                                </div>
                                <div class="legend__title">
                                    {{$t(`${legend.title}`)}}
                                </div>
                            </div>
                    </li>
                </ul>
                <layer/>
            </div>
        </transition>
    </div>
</template>

<script>
    import toggle from "@/mixins/toggle"
    import legends from '@/data/legends'
    //        {icon: 'marker-blue', title: 'legend-blue', id: 3},
    //        {icon: 'marker-stop--green', title: 'legend-stop--green', id: 6},
    const GYM_ID = 1;
    export default {
        mixins: [toggle],
        data() {
            return {
             checkbox: [],
             list: legends,
             isCheckAll: false,
            }
        },
        watch: {
            getCurrentServices(s) {
                const selectedServicesL = s.length;
                if(selectedServicesL === 0) {
                    this.checkbox = this.checkbox.filter(c => c !== GYM_ID)
                    this.updateCheckall
                    this.saveToLocalStorage()
                }
                if(selectedServicesL === this.servicesLength) {
                    if(!this.checkbox.includes(GYM_ID)) {
                        this.checkbox.push(GYM_ID)
                        this.updateCheckall
                        this.saveToLocalStorage()
                    }
                }
            }
        },
        props: {
            services: {
                type: Array
            }
        },
        methods: {
            fetchLocation(locationShowAll) {
                let selectedServices;
                if(locationShowAll) {
                    selectedServices = this.servicesAllId
                } else {
                    selectedServices = []
                }
                localStorage.setItem('servicesSelectList', JSON.stringify(selectedServices));
               try {
                   this.$store.dispatch('fetchLocations')
               } catch(e) {
                   console.log(e, 'error here')
               }
            },
            fetchAddresses() {
                try {
                    this.$store.dispatch('fetchAddresses')
                }catch(e) {
                    console.log(e, 'error handler')
                }
            },
         checkAll() {
             this.checkbox = [];
             if(this.isCheckAll) {
                 this.checkbox = this.selectedAllCheckboxes;
             }
             this.saveToLocalStorage()
            Promise.all([
                this.fetchAddresses(),
                this.fetchLocation(this.isCheckAll)
            ])

         },
        checkboxChangeHandler(service) {
            this.saveToLocalStorage()
            if(service.id === GYM_ID) {
                let locationsIsEnabled = this.checkbox.includes(GYM_ID);
                this.fetchLocation(locationsIsEnabled)
            } else {
                this.fetchAddresses()
            }
            this.updateCheckall

        },
        saveToLocalStorage() {
            localStorage.setItem('legendsSelectList', JSON.stringify(this.checkbox))
        },
        saveLegends() {
            let legendsFromStorage = JSON.parse(localStorage.getItem('legendsSelectList'))
            if(legendsFromStorage) {
                // set selected flags from storage
                this.checkbox = legendsFromStorage;
            } else {
                // set all flags
                this.checkbox = this.selectedAllCheckboxes;
            }
            this.updateCheckall
        },
        },
        computed: {
            getCurrentServices() {
                return this.$store.getters.getCurrentServices
            },
            updateCheckall() {
                let isSelected = this.checkbox.length === this.list.length;
                this.isCheckAll = isSelected;
                return isSelected
            },
            selectedAllCheckboxes() {
                let ids = this.list.map(l => l.id)
                return ids;
            },
            servicesLength() {
                return this.services.length
            },
            servicesAllId() {
              return this.services.map(s => s.id)
            },
        },
        mounted() {
            this.popupItem = this.$el
            this.saveLegends()
        },
    }

</script>
<style lang="sass" scoped>
    .legend
        z-index: 1
        position: relative
        width: 100%
        user-select: none
        &__list
            overflow-y: auto
            max-height: 412px
            scrollbar-color: #B3BECA
            scrollbar-width: thin
            height: 100%
            &::-webkit-scrollbar
                width: 4px
                background: white
                scrollbar-width: 4px
                height: 122px
            &::-moz-scrollbar,
            &::-o-scrollbar
                scrollbar-width: 4px
                height: 22px
            &::-webkit-scrollbar-track,
            &::-webkit-scrollbar-thumb
                background-color: white
                -ms-overflow-style: none
                scrollbar-width: 4px
                height: 22px
            &::-webkit-scrollbar-thumb
                background: #B3BECA
        &__action
            margin-bottom: 8px
            display: flex
            justify-content: flex-end
        &__inner
            text-align: left
            width: 350px
        &__item
            cursor: pointer
            justify-content: flex-start
            border-top: 1px solid #D7DDE1
            padding: 8px 15px
            min-height: 57px
            position: relative
            background-color: transparent
            +tr(background-color .3s ease)
            &:hover
                background-color: rgba(44, 100, 255, 0.05)
        &__checkbox
            position: absolute
            top: 50%
            transform: translateY(-50%)
            width: 95%
            z-index: 11
        &__item,
        &__content
            display: flex
            align-items: center
        &__content
            margin-left: 40px
            justify-content: center
        &__marker
            position: relative
            width: 40px
            height: 40px
            margin-right: 12px
        &__icon
            position: absolute
            +vcenter
        &__title
            font-size: 16px
            line-height: 20px
            flex: 1
            color: $color--dark
            +reg
            letter-spacing: 0.0764706px
    .v-input--checkbox
        ::v-deep
            .v-input--selection-controls__input
                margin-right: 0
                width: 100%
</style>